import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useServerUnreachable } from '../utils/serverReachability';

// When the cloud server can't be reached (no internet), offer Local Mode right
// here instead of making the user log out and find it on the login page. The
// session is left untouched, so everything is back as it was once the
// internet returns. Hidden when this page is already served from the box
// itself (a 192.168.x.x origin) — Local Mode would change nothing there.
const ON_LOCAL_IP = /^192\.168\./.test(window.location.hostname);

export default function OfflineLocalModeBanner() {
  const navigate = useNavigate();
  const offline = useServerUnreachable();
  const [dismissed, setDismissed] = useState(false);

  // Coming back online re-arms the banner for the next outage.
  useEffect(() => { if (!offline) setDismissed(false); }, [offline]);

  if (ON_LOCAL_IP || !offline || dismissed) return null;

  return (
    <div role="status" style={{
      position: 'fixed', top: 8, left: 8, right: 8, zIndex: 10000,
      maxWidth: 560, margin: '0 auto', borderRadius: 8, boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
      display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap',
      padding: '8px 12px', background: '#b45309', color: '#fff', fontSize: 13,
    }}>
      <span style={{ flex: '1 1 auto' }}>
        📡 App not reachable.
      </span>
      <button type="button" onClick={() => navigate('/local-mode')} style={{
        background: 'rgba(255,255,255,0.2)', color: 'inherit', border: 'none',
        borderRadius: 6, padding: '5px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer',
      }}>🏠 Try Local Mode</button>
      <button type="button" onClick={() => setDismissed(true)} style={{
        background: 'transparent', color: 'inherit', border: 'none', cursor: 'pointer', fontSize: 15, opacity: 0.8,
      }} aria-label="Dismiss">✕</button>
    </div>
  );
}
